export default "__VITE_ASSET__Bf3GFQB___"